import { getCookie } from '@/utils/cookie';

export const isAgeVerificationRequired = (): boolean => {
    const av = getCookie('av');

    if (!av) {
        return true;
    }

    const [avType, avRequired] = av.split(':');
    const agePass = getCookie('age_pass');

    return !((avType === 'simple' && agePass === '1') || (avType === 'advanced' && avRequired === 'False'));
};

export const isSimpleAvRequired = (): boolean => {
    const av = getCookie('av');
    const [avType, avRequired] = av.split(':');
    return avType === 'simple' && avRequired === 'True';
};
